import React from 'react';
import Dialog from 'aegisv2/Dialog';
import { primaryMain } from 'crehana-ui/styles/colors';
import Filter from 'crehana-icons/Filter';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';
import Text from 'crehana-ui/Text';
import { CATALOG_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';
import {
  clearAllFilters,
  clearSoftwareFilters,
  clearLevelFilters,
} from '../../redux/actions';

import Categories from './components/Categories';
import SubCategories from './components/Subcategories';
import Softwares from './components/Softwares';
import Levels from './components/Levels';
import Languages from './components/Languages';

import {
  Container,
  ButtonTitle,
  FilterButton,
  Inner,
  FixedElements,
  BackButton,
  Body,
  HeaderTitleWrapper,
  FilterItem,
} from './styles';

enum MENU_IDS {
  MENU = 'menu',
  CATEGORIES = 'categories',
  SOFTWARES = 'softwares',
  LEVELS = 'levels',
  LANGUAGES = 'languages',
}

type ViewType = {
  id: MENU_IDS;
  title: null | string;
};

// () => {
//   toggleFilterDialogAction();
// }

const Mobile: React.FC<{
  t(key: string): React.ReactNode;
  clearAllFilters(): void;
  clearSoftwareFilters(): void;
  clearLevelFilters(): void;
}> = ({
  t,
  clearAllFilters: clearAllFiltersAction,
  clearSoftwareFilters: clearSoftwareFiltersAction,
  clearLevelFilters: clearLevelFiltersAction,
}) => {
  const [view, setView] = React.useState<ViewType>({
    id: MENU_IDS.MENU,
    title: null,
  });
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (document.querySelector('#mainNode')) {
      if (open) {
        document.querySelector('#mainNode').style.maxHeight = '100vh';
        document.querySelector('#mainNode').style.overflow = 'hidden';
      } else {
        document.querySelector('#mainNode').style.maxHeight = 'initial';
        document.querySelector('#mainNode').style.overflow = 'unset';
        setView({
          id: MENU_IDS.MENU,
          title: null,
        });
      }
    }
  }, [open]);

  const openDialog = () => setOpen(true);
  const closeDialog = () => setOpen(false);

  const cleanFilters = () => {
    // clearAllFiltersAction();
    // console.log(view.id, MENU_IDS.SOFTWARES);
    switch (view.id) {
      case MENU_IDS.SOFTWARES:
        clearSoftwareFiltersAction();
        break;
      case MENU_IDS.LEVELS:
        clearLevelFiltersAction();
        break;
      default:
        clearAllFiltersAction();
        break;
    }
  };

  const onClickCategory = ({ id, name }) => {
    setView({ id: MENU_IDS.CATEGORIES, title: name });
  };

  const onClickSoftwares = () => {
    setView({ id: MENU_IDS.SOFTWARES, title: 'Softwares' });
  };

  const onClickLevels = () => {
    setView({ id: MENU_IDS.LEVELS, title: 'Niveles' });
  };

  const onClickLanguages = () => {
    setView({ id: MENU_IDS.LANGUAGES, title: 'Idiomas' });
  };

  const backButtonOnClick = {
    [MENU_IDS.CATEGORIES]: () => setView({ id: MENU_IDS.MENU, title: null }),
    [MENU_IDS.SOFTWARES]: () => setView({ id: MENU_IDS.MENU, title: null }),
    [MENU_IDS.LEVELS]: () => setView({ id: MENU_IDS.MENU, title: null }),
    [MENU_IDS.LANGUAGES]: () => setView({ id: MENU_IDS.MENU, title: null }),
    [MENU_IDS.MENU]: closeDialog,
  };

  const viewJsx = {
    [MENU_IDS.CATEGORIES]: <SubCategories closeDialog={closeDialog} />,
    [MENU_IDS.SOFTWARES]: <Softwares />,
    [MENU_IDS.LEVELS]: <Levels />,
    [MENU_IDS.LANGUAGES]: <Languages />,
  };

  return (
    <Container>
      <FilterButton onClick={openDialog}>
        <Filter size={16} color={primaryMain} />
        <ButtonTitle>{t('FILTER')}</ButtonTitle>
      </FilterButton>
      <Dialog open={open} onRequestClose={closeDialog} fullScreen noPadding>
        <Inner>
          {/* ====================== Header ====================== */}
          <FixedElements
            top
            className="pt-20 pb-20 pl-24 pr-24 z-10"
            onClick={backButtonOnClick[view.id]}
          >
            <div style={{ cursor: 'pointer' }}>
              <BackButton />
            </div>
            {view.id === MENU_IDS.MENU ? (
              <Text
                type="link"
                color="secondary-light"
                style={{ cursor: 'pointer' }}
              >
                {t('RETURN')}
              </Text>
            ) : (
              <HeaderTitleWrapper>
                <Text type="subtitle2" style={{ marginLeft: 0 }}>
                  {view.title}
                </Text>
              </HeaderTitleWrapper>
            )}
          </FixedElements>
          {/* ====================== END Header ====================== */}

          <Body className="w-full ">
            {view.id === MENU_IDS.MENU ? (
              <React.Fragment>
                <Categories onClickCategory={onClickCategory} />
                <FilterItem name="Softwares" onClick={onClickSoftwares} />
                <FilterItem name="Niveles" onClick={onClickLevels} />
                <FilterItem name="Idiomas" onClick={onClickLanguages} />
              </React.Fragment>
            ) : (
              viewJsx[view.id]
            )}
          </Body>

          {/* Footer */}
          {view.id !== MENU_IDS.CATEGORIES && view.id !== MENU_IDS.MENU && (
            <FixedElements
              bottom
              className="flex justify-around pt-12 pb-12 pl-24 pr-24 z-10"
            >
              <div onClick={cleanFilters}>
                <Text type="subtitle3" color="gray-dark">
                  {t('RESET_FILTERS')}
                </Text>
              </div>
              <PrimaryButton onClick={closeDialog} label="Filtrar" />
            </FixedElements>
          )}

          {/* END FOOTER */}
        </Inner>
      </Dialog>
    </Container>
  );
};

const MobileWithTranslation = withTranslation(CATALOG_TRANSLATION_KEY)(Mobile);

export default connect(
  null,
  { clearAllFilters, clearSoftwareFilters, clearLevelFilters },
)(MobileWithTranslation);
